/**
 * Converts GeoJSON [lon, lat] coordinates + radius to filter format (lat, lon, radius).
 * Returns undefined if coordinates or radius are missing.
 *
 * Note: GeoJSON stores coordinates as [longitude, latitude],
 * but the filter format expects (latitude, longitude, radius).
 */
export function formatCirclePosition(
  coordinates: number[] | undefined,
  radius: number | undefined,
): string | undefined {
  if (!coordinates || coordinates.length < 2 || radius == null) {
    return undefined;
  }
  return `(${coordinates[1]}, ${coordinates[0]}, ${radius})`;
}
